module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-base', {
    staticClass: "fzg-cf-metrics-modal-mobile",
    on: {
      "hide-modal": _vm.hideModal
    }
  }, [_c('template', {
    slot: "header"
  }), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": "https://static-image.xfz.cn/1686407757862/cf-metrics.jpg",
      "alt": ""
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1888ce94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/FzgChuangFuMetricsModalMobile.vue
// module id = 216
// module chunks = 0